import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { ComplaintSummary } from "@/api/backofficeRest/generated/model"
import {
  DynamicComplaintTopCategory,
  IDynamicComplaintSummary,
} from "@/mutators/complaint/ComplaintMutator.types"

export type ComplaintsSummaryRaw = ComplaintSummary

export const emptyDynamicSummary = {
  ageAverage: 0,
  total: 0,
  goodWillAmountTotal: 0,
} satisfies IDynamicComplaintSummary

function getTopCategoryFor(result: { count?: number; name?: string | null }) {
  return (result.count !== 0 ? result : undefined) as
    DynamicComplaintTopCategory | undefined
}

export const ComplaintMutatorParser: IParser<
  IDynamicComplaintSummary,
  ComplaintsSummaryRaw
> = {
  toDomain: (data: ComplaintsSummaryRaw): IDynamicComplaintSummary => {
    try {
      if (!data.total) {
        return emptyDynamicSummary
      }

      return {
        total: data.total,
        ageAverage: data.ageAverage,
        goodWillAmountTotal: data.goodWillAmountTotal,
        topCategory1: getTopCategoryFor(data.category1),
        topCategory2: getTopCategoryFor(data.category2),
        topCategory3: getTopCategoryFor(data.category3),
      }
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
